import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const FleetImport = ({ open, onClose, onDone }) => {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [report, setReport] = useState(null);
  const run = async () => {
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post("/fleet/import", fd);
      setReport(data);
      toast.success("Importazione completata");
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const close = () => { setReport(null); setFile(null); onClose(); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-lg" data-testid="fleet-import-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Importa flotta da Excel</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Stesso formato del file "mezzi": colonne AZIENDA, TARGA, MARCA E MODELLO, TIPOLOGIA BENE, SOC. NOLEGGIO-LEASYNG, SCAD. CONTRATTO, ASSEGNAZIONE, SCADENZE ASSICURAZIONE, SCADENZE REVISIONI, DATA ASSEGNAZIONE, SCAD. BOLLO, NOTE. I mezzi già presenti vengono aggiornati in base alla targa (i campi vuoti nel file non cancellano i dati esistenti).</p>
        <Input type="file" accept=".xlsx,.xlsm" onChange={(e) => setFile(e.target.files[0])} data-testid="fleet-import-file" />
        <Button disabled={!file || busy} onClick={run} data-testid="fleet-import-submit">{busy ? "Importazione…" : "Importa"}</Button>
        {report && (
          <div className="border bg-muted/40 p-4 text-sm" data-testid="fleet-import-report">
            <div><strong>{report.created}</strong> mezzi nuovi · <strong>{report.updated}</strong> aggiornati · <strong>{report.branches_created}</strong> sedi create</div>
            {report.errors.length > 0 && <ul className="mt-2 list-disc pl-5 text-red-700">{report.errors.map((e) => <li key={e.row}>Riga {e.row} ({e.plate}): {e.error}</li>)}</ul>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
